const __ = (ar, en, replacers = {}) => {
  const savedDirection = localStorage.getItem('direction')
  const isRTL = savedDirection === 'rtl'

  let text = isRTL ? ar : en

  let replacersKeys = Object.keys(replacers)
  if(replacersKeys.length > 0) {
    replacersKeys.map((key) => {
      text = text.replace(`{${key}`, replacers[key])
    })
  }

  return text
}

export default __
